'use client';

import { useEffect } from 'react';

/**
 * Page-specific title override for pages whose title depends on loaded data (WCAG 2.4.2, Q-2214), e.g. an
 * incident report's case number. `RouteTitle` keeps the table title in place and yields to this one while
 * the page is mounted. Pass null/undefined while the data is loading to keep the route title.
 */
export const TITLE_OVERRIDE_EVENT = 'engageiq:page-title-override';

let override: string | null = null;
export const getPageTitleOverride = () => override;

export function usePageTitle(title: string | null | undefined): void {
  useEffect(() => {
    override = title ? `${title} · EngageIQ` : null;
    window.dispatchEvent(new Event(TITLE_OVERRIDE_EVENT));
    return () => {
      override = null;
      window.dispatchEvent(new Event(TITLE_OVERRIDE_EVENT));
    };
  }, [title]);
}
